export const CATEGORIES_TOOLTIP = {
  relationships: "Social Relationships: connections that exist between people that are perceived to have personal meaning.",
  accomplishment: "Personal Accomplishment: feelings of not performing adequately.",
  cynicism: "Occupational Cynicism (Depersonalisation): is a state of indifference or a loss of interest in one's work and not seeing it as meaningful.",
  exhaustion: "Exhaustion: a state of chronic emotional and physical depletion.",
  global: "Your overall perception of the level of burnout symptoms."
}